const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;

export default API_BASE_URL;
export { GOOGLE_CLIENT_ID };